import infiniteBeauty from './../img/projects/infinite-beauty.webp';
import infiniteBeautyBig from './../img/projects/infinite-beauty-big.webp';

import jetpeel from './../img/projects/jetpeel.webp';
import jetpeelBig from './../img/projects/jetpeel-big.webp';

import fsFinland from './../img/projects/fs-finland.webp';
import fsFinlandBig from './../img/projects/fs-finland-big.webp';

import auramus from './../img/projects/auramus.webp';
import auramusBig from './../img/projects/auramus-big.webp';

import artist from './../img/projects/artist-portfolio.webp';
import artistBig from './../img/projects/artist-portfolio-big.webp';

import investClub from './../img/projects/invest-club.webp';
import investClubBig from './../img/projects/invest-club-big.webp';

import moveYou from './../img/projects/move-you.webp';
import moveYouBig from './../img/projects/move-you-big.webp';

import paperMagicImg from './../img/projects/puzzleBook.webp';
import paperMagicImgBig from './../img/projects/puzzleBookBig.webp';

const projectsMeta = [
  {
    img: infiniteBeauty,
    imgBig: infiniteBeautyBig,
    websiteLink: 'https://infinitebeauty.fi/',
    isPublished: true,
  },

  {
    img: jetpeel,
    imgBig: jetpeelBig,
    websiteLink: 'https://jetpeel.fi/',
    isPublished: true,
  },

  {
    img: fsFinland,
    imgBig: fsFinlandBig,
    websiteLink: 'https://fsfinland.fi/',
    isPublished: true,
  },

  {
    img: auramus,
    imgBig: auramusBig,
    websiteLink: 'https://www.auramus.fi/',
    isPublished: true,
  },

  {
    img: artist,
    imgBig: artistBig,
    isPublished: false,
  },

  {
    img: investClub,
    imgBig: investClubBig,
    websiteLink: 'https://invest-club-demo.vercel.app/',
    isPublished: true,
  },

  {
    img: moveYou,
    imgBig: moveYouBig,
    websiteLink: 'https://moveyou.fi/',
    isPublished: true,
  },

  {
    img: paperMagicImg,
    imgBig: paperMagicImgBig,
    websiteLink: '/paper-magic.html',
    isPublished: true,
  },
];

export { projectsMeta };
